<template>
  <v-card id="staffTeams">
    <v-card-text>
      <h2>Teams</h2>
      <template v-if="entity.teamsLeader">
        <h3>Leader</h3>
        <v-data-table
          :headers="headers"
          :items="entity.teamsLeader"
          v-if="entity.teamsLeader.length > 0"
          hide-actions
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td>
                <router-link
                  :to="{ name: 'team', params: { id: props.item.id } }"
                  >{{ props.item.id }}</router-link
                >
              </td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.name }}</td>
            </tr>
          </template>
        </v-data-table>
        <v-alert :value="entity.teamsLeader.length == 0" type="warning"
          >Not a leader of a team</v-alert
        >
      </template>
      <template v-if="entity.teamsMember">
        <h3>Member</h3>
        <v-data-table
          :headers="headers"
          :items="entity.teamsMember"
          v-if="entity.teamsMember.length > 0"
          hide-actions
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td>
                <router-link
                  :to="{ name: 'team', params: { id: props.item.id } }"
                  >{{ props.item.id }}</router-link
                >
              </td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.name }}</td>
            </tr>
          </template>
        </v-data-table>
        <v-alert :value="entity.teamsMember.length == 0" type="warning"
          >Not a member of a team</v-alert
        >
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Team",
  props: ["entity"],
  data() {
    return {
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Code",
          value: "code"
        },
        {
          text: "Name",
          value: "name"
        }
      ]
    };
  }
};
</script>
